<template>
  <div class="">
    <notification-modal     v-model:is-error-modal="errorGeneratingAllPointCertificates"
                            v-model:is-open="showCertificateEmailSent">
            <template   #title-content>
            <span   v-if="! errorGeneratingAllPointCertificates">Calibration Certificates Requested</span>
            <span   v-else>Error Generating Calibration Certificates</span>
        </template>
        <template>
            <div    v-if="! errorGeneratingAllPointCertificates"
                    class="flex flex-col">
                <span class="text-gray-900">Generating Certificates</span>
                <span class="text-gray-500">They will be emailed to you once ready.</span>
            </div>
            <div    v-else>
                <span class="text-gray-900">Error Generating Calibration Certificates</span>
                <span class="text-gray-500">Please contact support.</span>
            </div>
        </template>
    </notification-modal>
    <slide-over-panel v-model:show="showLifeTimesModal">
      <template #title>
        Custom Lifetimes
      </template>
      <template #content>
        <div v-for="(lifetime, probeType) in companyCalInfo.custom_probe_lifetimes">
          <div  class="flex flex-row">
              <!-- Description of Probe type and their lifetime -->
              <div class="flex flex-col items-start w-2/5 py-2">
                  <span class="text-gray-700">{{ probeType }}</span>
                  <span class="text-gray-500">{{ lifetime }} months</span>
              </div>

              <!-- Count of points in use -->
              <div  class="flex align-bottom flex-row items-end pb-2">
                  <span class="text-gray-500 pr-2">{{ getProbeCountByProbeType(probeType) }}</span>
                  <span class="text-gray-500">Points in use</span>
              </div>
          </div>  
        </div>

        <div v-if="Object.keys(companyCalInfo.custom_probe_lifetimes).length === 0">
          <span>No Custom Lifetimes.</span>
        </div>
      </template>
    </slide-over-panel>

    <slide-over-panel v-model:show="showEditModal">
      <template #title>
        Edit SNAP Calibration
      </template>

      <template #content>
        <calibration-table-partial
          :device_id="editingRow.probe_id"
          :snap-enroll="editingRow.snap_enrollment"
          :serial-number="editingRow.probe_serial"
          :departments="editingRow.departments"
          :department-select="editingRow.current_department"
          :permissions="permissions.getPermissions()"
          @save-success="showEditModal = false"
          @cancel-edit="showEditModal = false"
        ></calibration-table-partial>
      </template>
    </slide-over-panel>

    <h2>Calibration Info</h2>

    <div    class="flex justify-around">
      <!-- Upgrade Banner -->
      <div  v-show="showUpgradeBanner"
            class="w-2/3 mb-4 sm:flex 2xl:hidden">
        <banner-action
            :link="getUpgradeLink()"
        >
          <template #title>
            Probe Calibration History is not available at this feature level.
          </template>
          <template #action-text>
            Contact Sales
          </template>
        </banner-action>
      </div>
    </div>

    <ajax-table v-model:loading="ajaxTable.loading"
                v-model:search="ajaxTable.search"
                v-model:sort-by="ajaxTable.sortBy"
                v-model:sort-desc="ajaxTable.sortDesc"
                v-model:page="ajaxTable.page"
                v-model:items-per-page="ajaxTable.itemsPerPage"
                v-model:page-info="ajaxTable.pageInfo"
                :data="tableData"
                :headers="tableHeaders"
                :exportable="false"
                @loadData="loadData"
    >
      <template #above_table_center
                class="self-start flex items-center w-full md:w-auto ml:0 md:ml-2">
        <div v-if="!ajaxTable.loading"
             class="flex flex-col justify-center align-top px-4">
          <!-- Button to View All Certificates -->
          <div
            class="md:w-full lg:w-1/2 xl:w-2/3 2xl:w-1/4 flex flex-shrink-0 py-1 items-center rounded-md border border-solid border-blue-500 cursor-pointer">
            <div class="pr-2">
              <!-- Component that downloads the csv. -->
<!--                :data="meters"-->
              <div  v-if="isDownloadingCsv"
                    :class="iconLoading"
                    class="ml-1">
              </div>
              <download-excel   v-else
                  :fetch="exportProbeCalibrations"
                  :fields="meterCsvFields"
                  type="csv">
                <div  class="lnr icon-download2 cursor-pointer ml-3 text-gray-500 hover:text-gray-700"></div>
              </download-excel>
            </div>

            <div class="px-2 py-1 border-l border-solid border-blue-500 rounded-r-md">
<!--              <a :href="viewAllUrl" class="plain-link text-gray-800"-->
<!--                 target="_blank"-->
<!--                 @click="fathomGoalTrack">View All Certificates</a>-->
              <div  v-if="isRenderingAllPointCertificates"
                    class="flex flex-row items-center">
                <span   class="lnr icon-loading mr-1 animate-spin"></span>
                <span   >Loading Certificates</span>
              </div>
              <span     v-else
                        @click="triggerEmailOfProbeCalibrationCertificates">
                  View All Calibration Certificates
              </span>
            </div>
          </div>
          <!-- Snap Enrollment Status Check & Message -->
          <div @click="this.showLifeTimesModal = true"
               class="md:w-full lg:w-1/2 xl:w-2/3 2xl:w-1/4 flex flex-shrink-0 items-center mt-1 px-2 py-1 rounded-md border border-solid border-blue-500 cursor-pointer">
            <div v-if="companyCalInfo.snap_enrolled"
                 class="flex items-center">
              <div>
                <span class="lnr icon-checkmark-circle text-green-700 pr-4"></span>
              </div>
              <div class="flex flex-col">
                <span class="text-gray-900">SNAP Enrolled</span>
                <span class="text-gray-500">Renewal in {{ companyCalInfo.snap_month }}</span>
              </div>
            </div>

            <div v-else
                 class="flex items-center">
              <span class="lnr icon-circle-minus text-red-700 pr-1"></span>
              <span>SNAP Not Enrolled</span>
            </div>

          </div>

        </div>
      </template>

      <template #left-of-items-per-page>
        <!-- Upgrade Banner -->
        <div  v-show="showUpgradeBanner"
              class="hidden 2xl:flex">
          <banner-action
              :link="getUpgradeLink()"
              :vertical="true"
          >
            <template #title>
              Probe Calibration History is not available at this feature level.
            </template>
            <template #action-text>
              Contact Sales
            </template>
          </banner-action>
        </div>
      </template>

      <!-- Location Column -->
      <template #col-1="tableProps">
        <div class="flex-none">
          <div class="text-sm leading-5 text-gray-900">{{ tableProps.row.location }}</div>
          <div class="text-sm leading-5 text-gray-500">{{ tableProps.row.zone }}</div>
          <div class="text-sm leading-5 text-gray-500">{{ currentLocation(tableProps.row) }}</div>
        </div>
      </template>

      <!-- Point Column -->
      <template #col-2="tableProps">
        <div class="flex-none">
          <div class="text-sm leading-5 text-gray-900">
            <a class="sonicu-blue" :href="meterViewLink(tableProps.row)">{{ tableProps.row.point }}</a>
          </div>
          <div class="text-sm leading-5 text-gray-500">{{ tableProps.row.point_serial }}</div>
        </div>
      </template>

      <!-- Probe Column -->
      <template #col-3="tableProps">
        <div class="flex flex-auto justify-between">
          <div class="text-left">
            <div class="text-sm leading-5 text-gray-900">{{ probeSerial(tableProps.row) }}</div>
            <div class="text-sm leading-5 text-gray-500">{{ probeType(tableProps.row) }}</div>
            <div class="text-sm leading-5 text-gray-500">{{ calibrationDate(tableProps.row) }}</div>
            <div class="text-sm leading-5 text-gray-500">{{ calibrationExpirationDate(tableProps.row) }}</div>
          </div>

          <div class="self-center flex justify-around">
            <undecorated-link
              v-if="hasCalibration(tableProps.row)"
              :key="tableProps.row.id"
              :href="calibrationLicenseLink(tableProps.row)">
              <span
                :class="[tableProps.row.isExpired ? iconCalibrationCertificateExpired : iconCalibrationCertificate]"
                style="font-size: 2.0rem;"></span>
            </undecorated-link>
          </div>
        </div>
      </template>

      <template #col-4="tableProps">
        <undecorated-link v-if="canSave" v-on:click="openEditModal(tableProps.row)" class="ml-auto">
          <div class="flex flex-row flex-wrap">
            <span class="lnr icon-pencil cursor-pointer sonicu-gray" style="font-size: 2.0rem;"></span>
          </div>
        </undecorated-link>
      </template>
    </ajax-table>
  </div>
</template>

<script>
import axios from "axios"
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
import {iconNamesMixin} from '@/mixins/IconNamesMixin';
import {ajaxTableMixin} from "@/mixins/ajaxTableMixin";
import AjaxTable from "@/components/elements/AjaxTable";
import SlideOverPanel from "@/components/elements/SlideOverPanel";
import FloatingInput from "@/components/elements/FloatingInput";
import Select2 from "@/components/elements/select2"
import ButtonBluePrimary from "@/components/elements/buttons/ButtonBluePrimary";
import ButtonGreenPrimary from "@/components/elements/buttons/ButtonGreenPrimary";
import _ from "lodash";
import UndecoratedLink from "@/components/EnterpriseDashboard/undecorated-link";
import CalibrationTablePartial from "@/components/Calibration/CalibrationTablePartial";
import JsonExcel from "@/components/JsonExcel";
import BannerAction from "@/components/Banners/BannerAction";
import ButtonBlueSecondary from "../elements/buttons/ButtonBlueSecondary.vue";
import NotificationModal from "../elements/NotificationModal.vue";

export default {
  name: "CalibrationIndex",
  mixins: [SonicuCoreMixin, iconNamesMixin, ajaxTableMixin,],
  components: {
      NotificationModal,
      ButtonBlueSecondary,
    BannerAction,
    CalibrationTablePartial, UndecoratedLink, ButtonGreenPrimary, ButtonBluePrimary,
    FloatingInput, SlideOverPanel, AjaxTable, Select2, 'download-excel': JsonExcel
  },
  props: {
    viewAllUrl: String,
    showUpgradeBanner: {
      type: Boolean,
      default: false
    },
    companyName: String,
  },
  data() {
    return {
      tableHeaders: [
        {
          name: 'Location',
          key: 'name',
          sortBy: '',
        },
        {
          name: 'Point',
          key: 'type',
          sortBy: '',
        },
        {
          name: 'Probe & Calibration',
          key: 'meters',
          sortBy: 'expiration_status',
        },
        {
          name: '',
          key: 'enabled',
          sortBy: '',
        }
      ],
      tableData: [],
      allowedPoints: [],

      // Editing Modal
      showEditModal: false,
      editingRow: null,
      name: '',
      companyCalInfo: {},
      showLifeTimesModal: false,
      showCertificateEmailSent: false,
      errorGeneratingAllPointCertificates: false,
      requestNumber: 0,
      meters: [],
      meterCsvFields: {
        'Calibration Id': 'calibration_id',
        'Area': 'location',
        'Zone': 'zone',
        'Point Name': 'point',
        'Point Serial': 'point_serial',
        'Probe Serial': 'probe_serial',
        'Probe Type': 'probe_type',
        'Calibration Date': 'calibration_date',
        'Expiration Date': 'calibration_expiration_date',
        'Address': {
          callback: this.currentLocation,
        },
        'Calibration Report': {
          callback: (value) => {
            let suffix = this.calibrationLicenseLink(value)
            return window.location.hostname + suffix
          }
        },
        'Site Name': 'company',
      },
      isDownloadingCsv: false,
      isRenderingAllPointCertificates: false,
    }
  },
  created() {
    // this.loadCompany()
    this.ajaxTable.sortDesc = true
  },
  mounted() {

  },
  methods: {
    loadData() {
      this.ajaxTable.loading = true
      this.ajaxTable.requestNumber++
      let params = JSON.parse(JSON.stringify(this.ajaxTable))
      params.requestNumber = this.ajaxTable.requestNumber
      axios.get(this.company.buildCompanyApiInternalRoute('calibration-info'), {
        params: params,
      }).then(response => {
        let data = response.data
        if (`${data.meta.requestNumber}` !== `${this.ajaxTable.requestNumber}`) {
          return
        }
        this.meters = []

        data.data.forEach((item) => {
          let isExpired = false
          let probeType = (item.device.probe_serial === '')
            ? 'No Probe Information'
            : 'No Probe Type'
          if (item.probe_calibration.length > 0) {
            probeType = item.probe_calibration[0].probe_type
            isExpired = item.probe_calibration[0].isExpired
          }
          this.meters.push({
            company: this.companyName,
            location: item.area.name,
            zone: item.zone.name,
            point: item.meter.name,
            point_id: item.meter.id,
            point_serial: item.meter.serial_number,
            probe_calibrations: item.probe_calibration,
            probe_id: item.device.id,
            probe_serial: item.device.probe_serial,
            probe_type: probeType,
            isExpired: isExpired,
            calibration_date: item.device.calibration_date,
            calibration_expiration_date: item.device.calibration_expiration_date,
            departments: item.address,
            current_department: item.device.address_id
              ? String(item.device.address_id)
              : null,
          })
        });

        this.tableData = this.meters

        this.companyCalInfo.snap_enrolled = data.meta.snap.snap_enrolled
        this.companyCalInfo.snap_month = data.meta.snap.snap_month
        this.companyCalInfo.custom_probe_lifetimes = data.meta.custom_probe_lifetimes
        this.companyCalInfo.custom_probe_lifetimes_count = data.meta.custom_probe_lifetimes_count

        this.ajaxUpdateTableData(data)
      }).catch(error => {
        console.log(error)
      }).then(() => {
        this.ajaxTable.loading = false
      })
    },
    triggerEmailOfProbeCalibrationCertificates() {
        console.log("triggerEmailOfProbeCalibrationCertificates triggered")
        this.isRenderingAllPointCertificates = true
        this.errorGeneratingAllPointCertificates = false
        axios.post(this.company.buildCompanyApiInternalRoute('files/email-probe-calibration-certificates'), {

        }).then((response) => {
            console.log(response)
        }).catch(response => {
            this.errorGeneratingAllPointCertificates = true
        }).finally(() => {
            this.isRenderingAllPointCertificates = false
            this.showCertificateEmailSent = true
        })
    },
    async exportProbeCalibrations() {
      this.isDownloadingCsv = true
      let params = JSON.parse(JSON.stringify(this.ajaxTable))
      params.requestNumber = this.ajaxTable.requestNumber
      params.itemsPerPage = this.ajaxTable.pageInfo.total.toString()

      // Response from axios.
      let response = await axios.get(this.company.buildCompanyApiInternalRoute('calibration-info'), {
        params: params,
      })
      let data = response.data.data

      // Add specific data to the csv export fields.
      _.each(data, (meterData) => {
          let isExpired = false
          let probeType = (meterData.device.probe_serial === '')
              ? 'No Probe Information'
              : 'No Probe Type'
          let probeId = null
          if (meterData.probe_calibration.length > 0) {
              probeType = meterData.probe_calibration[0].probe_type
              isExpired = meterData.probe_calibration[0].isExpired
              probeId = meterData.probe_calibration[0].id
          }

          meterData.calibration_id = probeId
          meterData.current_department = meterData.device.address_id
              ? String(meterData.device.address_id)
              : null
          meterData.departments = meterData.address
          meterData.company = this.companyName
          meterData.location = meterData.area.name
          meterData.zone = meterData.zone.name
          meterData.point = meterData.meter.name
          meterData.point_id = meterData.meter.id
          meterData.point_serial = meterData.meter.serial_number
          meterData.probe_calibrations = meterData.probe_calibration
          meterData.probe_id = meterData.device.id
          meterData.probe_serial = meterData.device.probe_serial
          meterData.probe_type = probeType
          meterData.isExpired = isExpired
          meterData.calibration_date = meterData.device.calibration_date
          meterData.calibration_expiration_date = meterData.device.calibration_expiration_date
          meterData.departments = meterData.address
          meterData.current_department = meterData.device.address_id
              ? String(meterData.device.address_id)
              : null
      })

      this.isDownloadingCsv = false
      return data
    },
    openEditModal(row) {
      console.log('openEditModal triggered')
      this.editingRow = row
      this.showEditModal = true
    },
    currentLocation(meter) {
      if (meter.current_department !== null) {
        return 'Located at ' + meter.departments[meter.current_department]
      }
      return 'No Address Information'
    },
    probeSerial(meter) {
      if (meter.probe_serial !== null) {
        return meter.probe_serial
      }
    },
    probeType(meter) {
      return meter.probe_type
    },
    calibrationDate(meter) {
      if (meter.probe_serial === '') {
        return null
      }
      if (this.hasCalibration(meter)) {
        return 'Calibrated ' + meter.calibration_date
      } else {
        return 'No Calibration Info'
      }
    },
    calibrationExpirationDate(meter) {
      if (meter.probe_serial === '') {
        return null
      }
      if (this.hasCalibration(meter)) {
        return 'Expires ' + meter.calibration_expiration_date
      } else {
        return 'No Expiration Info'
      }
    },
    hasCalibration(meter) {
      return meter.calibration_date && meter.calibration_expiration_date;
    },
    meterViewLink(meter) {
      return this.company.buildCompanyRoute('meters/' + meter.point_id)
    },
    calibrationLicenseLink(meter) {
      return this.company.buildCompanyRoute('files/calibration-certificate?serial=' + meter.point_serial)
    },
    isExpired(row) {
      if (row.probe_calibration.length > 0) {
        return row.probe_calibration[0].isExpired
      }
      return true
    },
    fathomGoalTrack() {
      if (window.fathomLoaded) {
        window.fathom.trackGoal('70YSK2SE', 0);
      }
    },
    getUpgradeLink() {
      return this.company.buildCompanyRoute('upgrade') + '?feature=' + 'probeHistoryCalibrations'
    },
    getProbeCountByProbeType(probeType) {
      let count = 0
      // If the probe type is defined on the custom probe lifetime counts use that count
      if (! _.isNil(this.companyCalInfo.custom_probe_lifetimes_count[probeType])) {
        count = this.companyCalInfo.custom_probe_lifetimes_count[probeType]
      }

      return count
    },
  },
  computed: {
    allowedPointsOptions() {
      let keyedNames = {}
      _.forEach(this.allowedPoints, function (val) {
        keyedNames[val.serial_number] = val.name;
      })
      return keyedNames;
    },
    canSave() {
      // If we have any of these permissions we can save
      return this.permissions.can('edit_probe_serial') ||
        this.permissions.can('edit_snap_enrollment') ||
        this.permissions.can('edit_device_address')
    },
  },
  watch: {},
}
</script>

<style scoped>

</style>